import { Link } from 'react-router-dom';
import { Box, DraftingCompass, SlidersHorizontal, Camera } from 'lucide-react';
import './journeySteps.css';

export const JourneySteps = ({ current, roomTo = '/', libraryTo = '/library', studioTo = '/configure/product', photoTo, className = '' }) => {
  const [path, query] = studioTo.split('?');
  const photo = photoTo || `${path.replace(/\/photo$/, '')}/photo${query ? `?${query}` : ''}`;
  const steps = [[1, 'Showroom', roomTo, Box], [3, 'Design', studioTo, SlidersHorizontal], [4, 'Home photo', photo, Camera], [2, 'CAD library', libraryTo, DraftingCompass]];
  return <nav className={`journey-steps ${className}`} aria-label="Main navigation" data-testid="journey-steps">
    <ol>{steps.map(([n, label, to, Icon]) => <li key={n} className={n === current ? 'is-current' : ''}>
      <Link to={to} aria-current={n === current ? 'page' : undefined} data-testid={`journey-step-${n}`}><Icon size={19} aria-hidden="true" /><span className="journey-label">{label}</span></Link>
    </li>)}</ol>
  </nav>;
};
